import React, { useState, useEffect } from 'react';
import { InputText } from '../../../../../panda';

import { PairedInputMixin } from '../styled';

interface IProps {
  name: string;
  isPair?: boolean;
  setFn: (value: any) => void;
  step?: string;
  title?: string;
  type: string;
  value: string | number;
}

const BaseInputText = ({ name, setFn, step, title, type, value, isPair }: IProps) => {
  const [pvtValue, setPvtValue] = useState(value);

  useEffect(() => {
    if (Number(value) === Number(pvtValue)) return;
    setPvtValue(value);
  }, [value, pvtValue]);

  return (
    <InputText
      css={(isPair && PairedInputMixin) || ''}
      input={{
        value: pvtValue,
        name,
        onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
          e.preventDefault();
          setPvtValue(e.target.value);
          setFn(e.target.value);
        },
      }}
      isSmall
      isReverse
      inputType={type}
      step={step}
      meta={{}}
      title={title}
    />
  );
};

export default BaseInputText;
